import React, { ChangeEvent } from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';
import { Input } from '@app/form';
import { InformationPageField } from 'queries';
import { useTranslation } from 'react-i18next';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    backgroundColor: theme.colors.grayBackground,
    paddingLeft: theme.marginBase * 2,
    paddingRight: theme.marginBase * 2,
    paddingBottom: theme.marginBase * 2,
  },
  input: {
    margin: 0,
  },
}));

interface Props {
  field: InformationPageField;
  onChange: (field: InformationPageField) => any;
}

export const InformationPageBuilder = ({ field, onChange }: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });
  const { t } = useTranslation();

  return (
    <div className={classes.container}>
      <Input
        label={t('screeningForm.create.questionBuilder.description')}
        value={field.properties.description}
        containerClass={classes.input}
        small
        onChange={(e: ChangeEvent<HTMLInputElement>) =>
          onChange({
            ...field,
            properties: {
              ...field.properties,
              description: e.currentTarget.value,
            },
          })
        }
      />
    </div>
  );
};
